function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "icon_edit",
  "data-name": "icon/edit",
  d: "M1201.2,510.8l1.8-1.8a4.677,4.677,0,0,0,.96-1.112,1.982,1.982,0,0,0,0-1.776A4.677,4.677,0,0,0,1203,505a5.236,5.236,0,0,0-1.11-.964,2.01,2.01,0,0,0-1.78,0A5.236,5.236,0,0,0,1199,505l-1.82,1.819A10.961,10.961,0,0,0,1201.2,510.8Zm-5.47-2.523-6.87,6.871a4.093,4.093,0,0,0-.78.9,4.233,4.233,0,0,0-.32,1.146l-.61,3.077c-.07.332-.1.5-.01.593s.26.061.6,0l3.07-.615a4.211,4.211,0,0,0,1.15-.317,4.347,4.347,0,0,0,.9-.777l6.89-6.89A12.756,12.756,0,0,1,1195.73,508.273Z",
  transform: "translate(-1187.084 -503.828)",
  fill: "#2e368c",
  fillRule: "evenodd"
});

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.086,
    height: 17.089,
    viewBox: "0 0 17.086 17.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a4838cc6.svg";
export { ForwardRef as ReactComponent };